export default __webpack_public_path__ + "static/media/kaci-baum-2.9b929eea.jpg";